import React from 'react';

import useNavigation from '@zego/hooks/useNavigation';
import useCreateIrelandTaxiTelematicsLeadMutation from '@zego/mutations/useCreateIrelandTaxiTelematicsLeadMutation';
import { EVENT_TYPES, useTracking, withTrackingScope } from '@zego/tracking';
import { getUtmMutationData } from '@zego/utils';

import IrelandTaxiLeadForm from './IrelandTaxiLeadForm';

const IrelandTaxiLeadFormHandler = props => {
  const navigation = useNavigation();

  const { trackEvent, trackingContext } = useTracking();

  const {
    call: createIrelandTaxiTelematicsLead,
    data,
  } = useCreateIrelandTaxiTelematicsLeadMutation({});

  const _handleSubmit = (values, onComplete) => {
    const utmData = getUtmMutationData();
    const input = {
      givenNames: values['given-name'],
      lastName: values['family-name'],
      dateOfBirth: values.bday,
      phoneNumber: values.tel,
      email: values.email,
      eircode: values.eircode,
      attribution: {
        featureName: 'Web Sign up Form',
        locationName: trackingContext.locationName,
        utmParams: utmData,
      },
    };

    createIrelandTaxiTelematicsLead(
      {
        variables: {
          input,
        },
      },
      (_err, result) => {
        if (
          result?.createIrelandTaxiTelematicsLead?.__typename ===
          'CreateIrelandTaxiTelematicsLeadSuccess'
        ) {
          trackEvent('Landing Page Form - Personal details submitted', {
            eventType: EVENT_TYPES.LEAD,
            leadIdentifier:
              result.createIrelandTaxiTelematicsLead.user.customerNumber,
          });
          navigation.push({
            href: '/ie/promotions/new-taxi-insurance/success/',
          });
        }
        onComplete();
      },
    );
  };

  const errorMessage =
    data?.createIrelandTaxiTelematicsLead?.__typename ===
      'CreateIrelandTaxiTelematicsLeadError' &&
    data?.createIrelandTaxiTelematicsLead?.errorMessage;

  return (
    <IrelandTaxiLeadForm
      {...props}
      onSubmit={_handleSubmit}
      errorMessage={errorMessage}
    />
  );
};

export default withTrackingScope({
  featureName: 'Web Sign up Form',
})(IrelandTaxiLeadFormHandler);
